import { createSlice } from "@reduxjs/toolkit";

const initialSystemUser = {
  name: "",
  surname: "",
  phone1: "",
  phone2: "",
  username: "",
  password: "",
  isOtpActive: true,
  isSuperAdmin: false,
  isActive: true
};

const initialSystemUsersState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  systemUser: initialSystemUser
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const systemUserSlice = createSlice({
  name: "systemUsers",
  initialState: initialSystemUsersState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getSystemUsers
    systemUsersFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities =  authorities;
    },
    //getSystemUser
    systemUserFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.systemUser = action.payload.entity;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanSystemUsersState
    systemUsersStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.systemUser = initialSystemUser;
    }
  }
});